import {
  AudioRecordingError,
  AudioRecordingErrorSource,
  AudioRecordingErrorStage,
} from "@/domains/errors";
import { api } from "@/modules/api";
import { AssemblyAiToken } from "@/modules/audio-recording/audio-recording.types";
import { getNetworkInfo } from "@/domains/network/status";

export const assemblyAiTokenProvider = async (): Promise<AssemblyAiToken> => {
  let response;
  try {
    response = await api.post("/v2/voice/start_transcription", {
      params: { query: { version: "v3" } },
    });
  } catch (error) {
    const networkInfo = getNetworkInfo();
    throw new AudioRecordingError({
      source: AudioRecordingErrorSource.AssemblyAI,
      stage: AudioRecordingErrorStage.TokenFetch,
      message: error instanceof Error ? error.message : "Failed to fetch AssemblyAI token.",
      originalError: error instanceof Error ? error : undefined,
      details: {
        endpoint: "/v2/voice/start_transcription",
        online: networkInfo.online ?? undefined,
        effectiveType: networkInfo.effectiveType,
        rtt: networkInfo.rtt,
        downlink: networkInfo.downlink,
        saveData: networkInfo.saveData,
      },
    });
  }

  const token = response.data?.token;

  if (!token) {
    throw new AudioRecordingError({
      source: AudioRecordingErrorSource.AssemblyAI,
      stage: AudioRecordingErrorStage.TokenFetch,
      message: "AssemblyAI token missing in response.",
      details: {
        endpoint: "/v2/voice/start_transcription",
      },
    });
  }

  return { token };
};
